/* eslint-disable react/no-unknown-property */
import React from "react";
import PropTypes from "prop-types";

import { TODOListActionButton } from "./todo_list_action_button";
import AppointmentRequestLinkButton from "../appointment_request/appointment_request_link_button";
import { ReScheduleButton } from "./re_schedule_button";

const TODOListActionButtonContainer = ({ todoListData, selectedDate, isRecurringToDoList }) => {
  const toDoListDate = selectedDate ? selectedDate : todoListData.to_do_date;
  const {
    first_appointment_request_id,
    shift_num,
    is_incomplete,
    is_complete,
    to_do_list_time,
    location,
    state,
    recurrence_start_date,
    to_do_list_title
  } = todoListData;
  return (
    <div className="to-do-list-action-button-container">
      <a
        className="button is-warning ccw-button ccw-button--warning ccw-button--icon to-do-list-edit-button todo-action-button todo-action-button--edit"
        href={`/to_do_lists/${todoListData.id}/edit`}
        aria-label={`Edit ${to_do_list_title || "task"}`}
        data-explorator_test_id={`to_do_list_edit_button_${to_do_list_title}`}
        explorator_test_id={`to_do_list_edit_button_${to_do_list_title}`}
      >
        <i className="fas fa-edit" aria-hidden="true" />
      </a>
      <AppointmentRequestLinkButton
        attachedUser={todoListData.user_name}
        toDoListID={todoListData.id}
        toDoListTaskType={todoListData.task_type}
        isToDoListRecurring={isRecurringToDoList}
        appointmentRequestID={first_appointment_request_id}
        date={toDoListDate}
        time={to_do_list_time}
        location={location}
      />
      <TODOListActionButton
        time={to_do_list_time}
        todoListDate={toDoListDate}
        todoListId={todoListData.id}
        shiftNumber={shift_num}
        isInComplete={is_incomplete}
        isComplete={is_complete}
        toDoListTitle={to_do_list_title}
        state={state}
        recurrence_start_date={recurrence_start_date}
        type="complete"
      />
      <TODOListActionButton
        time={to_do_list_time}
        todoListDate={toDoListDate}
        todoListId={todoListData.id}
        shiftNumber={shift_num}
        isInComplete={is_incomplete}
        isComplete={is_complete}
        toDoListTitle={to_do_list_title}
        state={state}
        recurrence_start_date={recurrence_start_date}
        type="incomplete"
      />
      <TODOListActionButton
        time={to_do_list_time}
        todoListDate={toDoListDate}
        todoListId={todoListData.id}
        shiftNumber={shift_num}
        isInComplete={is_incomplete}
        isComplete={is_complete}
        toDoListTitle={to_do_list_title}
        state={todoListData.state}
        recurrence_start_date={todoListData.recurrence_start_date}
        type="skip"
      />
      <TODOListActionButton
        time={to_do_list_time}
        todoListDate={toDoListDate}
        todoListId={todoListData.id}
        shiftNumber={shift_num}
        isInComplete={is_incomplete}
        isComplete={is_complete}
        toDoListTitle={to_do_list_title}
        state={state}
        recurrence_start_date={recurrence_start_date}
        type="inprogress"
      />
      {!todoListData.recurrence_start_date && (
        <ReScheduleButton
          todoListDate={toDoListDate}
          todoListTime={to_do_list_time}
          todoListId={todoListData.id}
          shiftNumber={shift_num}
          toDoListTitle={to_do_list_title}
          hasAppointmentRequest={todoListData.has_appointment_request}
          matchedPeerName={todoListData.user_name}
        />
      )}
    </div>
  );
};

TODOListActionButtonContainer.propTypes = {
  todoListData: PropTypes.object,
  selectedDate: PropTypes.string,
  has_appointment_request: PropTypes.bool,
  isRecurringToDoList: PropTypes.bool
};

export default TODOListActionButtonContainer;
